import styled from '@emotion/styled';
import { isClient } from '@teamsparta/utils';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

import { useDrag } from '@/hooks/common';
import { env } from '@/lib/utils/env';

import Portal from '../Portal';

const TEST_PAYMENT_QUERY_KEY = 'paymentType';
const X_OFFSET = 150;
const Y_OFFSET = 60;

export function TestPaymentFloatingButton() {
  const router = useRouter();

  const initialPosition = isClient()
    ? {
        x: window.innerWidth - X_OFFSET,
        y: window.innerHeight - Y_OFFSET,
      }
    : { x: 0, y: 0 };

  const {
    ref: buttonRef,
    position,
    onMouseDown,
    onTouchStart,
  } = useDrag<HTMLDivElement>({
    initialPosition,
  });

  const shouldRender =
    env.NEXT_PUBLIC_ENV !== 'PRODUCTION' &&
    (router.asPath.includes('apply') || router.asPath.includes('payment'));

  const isActive = router.query[TEST_PAYMENT_QUERY_KEY] === 'test';

  const toggleActive = useCallback(() => {
    const newIsActive = !isActive;
    const newQuery = { ...router.query };

    if (newIsActive) {
      newQuery[TEST_PAYMENT_QUERY_KEY] = 'test';
    } else {
      delete newQuery[TEST_PAYMENT_QUERY_KEY];
    }

    router.replace(
      {
        pathname: router.pathname,
        query: newQuery,
      },
      undefined,
      { shallow: true },
    );
  }, [isActive, router]);

  if (!shouldRender) {
    return null;
  }

  return (
    <Portal selector='body'>
      <FloatingButton
        ref={buttonRef}
        $isActive={isActive}
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`,
        }}
        onMouseDown={onMouseDown}
        onTouchStart={onTouchStart}
        onClick={toggleActive}
      >
        {isActive ? '테스트 결제 켜짐' : '테스트 결제 꺼짐'}
      </FloatingButton>
    </Portal>
  );
}

const FloatingButton = styled.div<{ $isActive: boolean }>`
  position: fixed;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: bold;
  color: white;
  cursor: move;
  user-select: none;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  z-index: 9999;
  transition: background-color 0.3s;
  background-color: ${({ $isActive }) => ($isActive ? '#4CAF50' : '#F44336')};
`;
